<mat-card class="tcb-box-shadow abandonedAppContainer card" fxFlex fxLayout="column">
  <img height="100%" width="75px" src="{{abandonedCardRules.abandonedIcon}}" alt="Abandoned application"/>
  <h3>Application Abandoned</h3>
  <p>We are sorry but your Application has been Abandoned because of inactivity.</p>
  <div fxLayoutAlign="end end">
    <button mat-flat-button class="primary-btn-action" color="primary" (click)="closeButton()">CLOSE</button>
  </div>
</mat-card>
